/**
 * Home petal / transition feature flags.
 * See DEV_LOG.md → "Home cherry blossom petals".
 *
 * ENABLE_PETAL_TRANSITIONS: intro + exit screen-covering gusts (delays navigation).
 * Set to true to restore; ambient windfall is independent via ENABLE_AMBIENT_PETALS.
 */
export const ENABLE_PETAL_TRANSITIONS = false;
export const ENABLE_AMBIENT_PETALS = true;
